export enum ValidatorDNSTypes {
    IPV4 = 'IPV4',
    IPV6 = 'IPV6',
    STRING2_DOMAIN_NAME_OPT_DOT = 'STRING2_DOMAIN_NAME_OPT_DOT',
    STRING2_DOMAIN_NAME_MX = 'STRING2_DOMAIN_NAME_MX',
    STRING1_CNAME_A_SAME_VALIDATION = 'STRING1_CNAME_A_SAME_VALIDATION',
    STRING2_CNAME = 'STRING2_CNAME',
    STRING2_DNAME = 'STRING2_DNAME',
    STRING2_TXT = 'STRING2_TXT',
    STRING2_SRV = 'STRING2_SRV',
    STRING1 = 'STRING1',
    STRING1_NOT_AT = 'STRING1_NOT_AT',
    REQUIRED = 'REQUIRED',
    NUMERIC = 'NUMERIC'
}